import Axios, { AxiosInstance } from 'axios';

class AxiosService {
  /**
   * We bind various interceptors to the global Axios object.
   * If an instance without these interceptors is needed,
   * use the getInstance method instead of the global Axios object.
   */
  public bindGlobal() {
    Axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    Axios.defaults.headers.common = { 'X-Requested-With': 'XMLHttpRequest' };
    Axios.defaults.withCredentials = true;
  }

  public getInstance(): AxiosInstance {
    return Axios;
  }

}

export default new AxiosService();
